module.exports = __webpack_public_path__ + "static/logo-forbes-b66d36a128dabda4e0eb8621d6765565.png";